
<template>
    <section>
        <h1 class="title is-6">
            Apply your license code
        </h1>
        <div class="has-text-centeredx">
            <div class="block">
                <b-field>
                    <b-taginput 
                        expanded
                        maxtags="4" has-counter 
                        attached 
                        ellipsis
                        icon="label"
                        placeholder="Add a code"
                        aria-close-label="Delete this code"
                        v-model="promoCode"
                        :on-paste-separators="[' ', ',', ';', '\\n']"
                        :before-adding="beforeAdd"
                        @input="verifyCode">
                        </b-taginput>
                        <p class="control">

                        <b-button expanded @click="verifyCode">
                            Add
                        </b-button> 
                        </p>
                </b-field>
                <b-taglist attached>
                    <b-tag v-for="(code, index) in promoCode" :key="index" type="is-primary" size="is-medium">
                        {{ code }}
                        <b-icon
                            icon="close"
                            size="is-small"
                            type="is-danger"
                            @click="promoCode.splice(index, 1)"
                        ></b-icon>
                    </b-tag>
                </b-taglist>
                
            </div>
            <b-button expanded @click="applyPromoCode" type="is-primary" v-if="enableApplyButton">
                Apply {{ promoCode.length > 1 ? promoCode.length + ' codes' : promoCode.length + ' code' }}
            </b-button>
            <hr>
        </div>
</section>
</template>

<script>

   export default {
     props: ["currentUser", "productPackages"],
     name: "PromoCode",
     data: function() {
    return {
        showPromoCode: true,
        havePromoCode: false,
        promoCode: [],
        validPromoCode: "",
        selectedPromoCode: null,
        enableApplyButton: false,
    }},
    computed: {
        allPromoCodes() {
            return this.$store.state.promoCode
        }
    },
    methods: {
        async isValid(code) {
            if (code == undefined && code.length != 20){
                return false
            }
            try {
                return await this.$store.dispatch('validateCode', code);
            } catch (error) {
                console.error("Error validating promo code:", error);
                return false
            }
        },
        beforeAdd(code){
            let ok = (code.length == 20) ? true : false
            if (!ok) this.openAlert(false, code);
            return ok
        },
        async verifyCode(codes) {
            const code = codes[codes.length-1]
            console.log("verifyCode", code);
            const apply = await this.isValid(code)
            this.openAlert(apply, code);
            if (!apply){
                this.promoCode.pop()
            } else  if (this.promoCode.length > 0){
                this.enableApplyButton = true
            }
        },
        openAlert(apply, code){
            if (apply){
                this.$buefy.toast.open({
                    message: `License code ${code} verified!`,
                    type: 'is-success'
                })
            } else {
                this.$buefy.toast.open({
                    message: `License code ${code} not found!`,
                    type: 'is-danger'
                })
            }
        },
        applyPromoCode(){
            
            if (this.promoCode.length < 1){
                this.$buefy.dialog.alert({
                    "message": "Please enter a valid license code",
                })
                return;
            }
            // concat two arrays
            // get the number of tiers
            // is life-time license
            const countArrayPositions = (arr) => {
              return arr.length;
            };

            const isLTL = true
            
            const n_tier = countArrayPositions(this.promoCode)
            
            //const n_tier = Math.min(this.promoCode.length, 4)

            const tier_to_package = n_tier
            
            // get the credits
            const credits = Math.min(this.productPackages[tier_to_package], 160000)
            // get the plan
            const plan = ( tier_to_package < 3 ) ? 'starter' : 'pro'
            const capitalizedPlan = plan.charAt(0).toUpperCase() + plan.slice(1)
            if (this.promoCode){

            // raise a buefy alert confirm
            this.$buefy.dialog.confirm({
                message: `Please confirm to apply your code<br><br><b>Package Tier ${n_tier}</b><br><b>Exclusive AppSumo deal with ${credits} credits.</b>`,
                confirmText: 'Continue',
                cancelText: 'Cancel',
                onConfirm: () => {
                    const codeUpdate = {
                        userId: this.currentUser.id,
                        update: {
                            payment: {
                                method: 'appsumo',
                                license: 'lifetime',
                                licenseCode: this.promoCode,
                            }
                        }
                    }
                    this.$store.dispatch('updateUser', codeUpdate)
                    // update the promo code
                    this.promoCode.forEach((code) => {
                        const codeUpdate = {
                            userId: this.currentUser.id,
                            promoCodeId: code
                        }
                        this.$store.dispatch('applyPromoCode', codeUpdate)
                    })

                    this.$router.push({
                        path: '/checkout/checkout/appsumo/success',
                        query: {
                            session_id: `AppSumo-${this.currentUser.id}`,
                            p: plan,
                            c: credits,
                            o: this.isOnboarding ? 1 : 0,
                            l: 'lifetime'
                        }
                    })
                },
            });
          }

        }
    },
    created (){
        this.promoCode = ( this.currentUser.payment.licenseCode ? this.currentUser.payment.licenseCode : [] )
    }
   };
</script>